/*
  "Ready to Ship" / "Made to Order" badge for a product.

  A product's availability is the "Availability Status" metafield
  (custom.availability_status), which only accepts the two values below.
  Products without a value get no badge, so the badge appears only where the
  metafield has been filled in.

  This table is the single rule for the USF collection and search cards.
  snippets/availability-badge.liquid draws the same badge on theme-rendered
  cards and the product page; keep the two in step.

  Pure functions only: no DOM access, so the rule can be unit-tested.
*/
(function (root) {
  var BADGES = {
    'Ready to Ship': { label: 'Ready to Ship', modifier: 'ready-to-ship' },
    'Made to Order': { label: 'Made to Order', modifier: 'made-to-order' }
  };

  // Metafield value -> { label, modifier }, or null when there is no badge to show.
  function badgeFor(value) {
    if (typeof value !== 'string') {
      return null;
    }
    var badge = BADGES[value.trim()];
    return badge ? { label: badge.label, modifier: badge.modifier } : null;
  }

  var api = { badgeFor: badgeFor };

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.WellingtonsAvailability = api;
  }
})(typeof window !== 'undefined' ? window : this);
